import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Skeleton } from 'antd';
import { useTheme } from '../../../context/ThemeContext';
import {
  StyledCard,
  WeeklyBreakdownItem,
  WeeklyBreakdownHeader,
  WeeklyBreakdownWeek,
  WeeklyBreakdownAmount,
  StyledProgress,
  EmptyStateText,
  CardTitle,
} from './Styles';
import { addCommasInPrices, EMPTY_STATE_MESSAGES } from './constants';
import { WeeklyBreakdownSectionProps } from './types';


const WeeklyBreakdownSection: React.FC<WeeklyBreakdownSectionProps> = ({
  reportData,
  loading = false,
}) => {
  const { isDarkMode } = useTheme();
  const theme = { mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark' };

  if (loading) {
    return (
      <ThemeProvider theme={theme}>
        <StyledCard title={<CardTitle level={4}>Weekly Breakdown</CardTitle>}>
          {Array.from({ length: 4 }).map((_, index) => (
            <WeeklyBreakdownItem key={index}>
              <Skeleton active paragraph={{ rows: 1 }} />
            </WeeklyBreakdownItem>
          ))}
        </StyledCard>
      </ThemeProvider>
    );
  }

  if (!reportData?.weeklyBreakdown) {
    return (
      <ThemeProvider theme={theme}>
        <StyledCard title={<CardTitle level={4}>Weekly Breakdown</CardTitle>}>
          <EmptyStateText>{EMPTY_STATE_MESSAGES.WEEKLY_BREAKDOWN}</EmptyStateText>
        </StyledCard>
      </ThemeProvider>
    );
  }

  const weeklyData = reportData.weeklyBreakdown;
  const weeks = Object.keys(weeklyData);
  const maxValue = Math.max(...Object.values(weeklyData));

  return (
    <ThemeProvider theme={theme}>
      <StyledCard title={<CardTitle level={4}>Weekly Breakdown</CardTitle>}>
        {weeks.map((week) => {
          const value = weeklyData[week];
          const percentage = maxValue > 0 ? (value / maxValue) * 100 : 0;
          
          return (
            <WeeklyBreakdownItem key={week}>
              <WeeklyBreakdownHeader>
                <WeeklyBreakdownWeek>{week}</WeeklyBreakdownWeek>
                <WeeklyBreakdownAmount>
                  ${addCommasInPrices(value)}
                </WeeklyBreakdownAmount>
              </WeeklyBreakdownHeader>
              <StyledProgress
                percent={percentage}
                showInfo={false}
                strokeColor={{
                  '0%': '#10b981',
                  '100%': '#059669',
                }}
              />
            </WeeklyBreakdownItem>
          );
        })}
      </StyledCard>
    </ThemeProvider>
  );
};

export default WeeklyBreakdownSection;
